import React, { useCallback, useEffect, useState } from "react";
import {
  Col,
  Row,
  Form,
  Flex,
  Image,
  Table,
  Select,
  Button,
  Divider,
  GetProps,
  DatePicker,
  Typography,
  ConfigProvider,
  type FormProps,
  type TableColumnsType,
} from "antd";
import "dayjs/locale/vi";
import ExcelJS from "exceljs";
import { IExcelColumn } from "antd-table-saveas-excel/app";
import dayjs from "dayjs";
import "./Report.scss";
import { formatPrice, handleGetUrlGuide } from "../../utils/helpers";
import IconFileExport from "../../components/Icons/IconFileExport";
import IconExportExcel from "../../components/Icons/IconExportExcel";
import IconExclamationCircle from "../../assets/images/ExclamationCircle.svg";
import { DataReport, ValueOptions } from "../../types/report";
import { DEFAULT_PAGE_SIZE } from "antd/es/table/hooks/usePagination";
import { Constant } from "../../config/constant";
import { toast } from "react-toastify";
import { getListRouteAPI } from "../../api/report";
import { RouteItemProps } from "../../types";
import { optionsBookingDate } from "./ReportDetailCompany";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import {
  getListReportTotalRouteCompany,
  getListReportTotalRouteCompanyExcel,
  setFilterBookingDate,
  setFilterRangeDate,
  setFilterRoute,
  setPerPage,
} from "../../redux/slice/report/reportTotalRouteCompanySlice";
import TutorialsVideo from "../../components/TutorialsVideo";

dayjs.locale("vn");
const { RangePicker } = DatePicker;
type RangePickerProps = GetProps<typeof DatePicker.RangePicker>;

type FieldType = {
  type_date_report: string;
  range_date_report: string;
  route: number | string;
};

const ReportTotalRouteCompany = () => {
  const [form] = Form.useForm();
  const dispatch = useAppDispatch();
  const [page, setPage] = useState<number>(1);
  const [timeReport, setTimeReport] = useState<RangePickerProps["value"]>();
  const [optionsRoute, setOptionsRoute] = useState<ValueOptions[]>([]);

  const pagination = useAppSelector(
    (state) => state?.reportTotalRouteCompany?.pagination
  );
  const listReport = useAppSelector(
    (state) => state?.reportTotalRouteCompany?.listReport
  );
  const loadingListReport = useAppSelector(
    (state) => state?.reportTotalRouteCompany?.loading
  );
  const totalCommission = useAppSelector(
    (state) => state?.reportTotalRouteCompany?.total_commissions
  );
  const totalPrice = useAppSelector(
    (state) => state?.reportTotalRouteCompany?.total_prices
  );
  const listFilter = useAppSelector(
    (state) => state?.reportTotalRouteCompany?.filter
  );
  const totalBookingsAgent = useAppSelector(
    (state) => state?.reportTotalRouteCompany?.total_bookings_agent
  );
  const totalBookingsCarCompany = useAppSelector(
    (state) => state?.reportTotalRouteCompany?.total_bookings_car_company
  );
  const totalRealRevenue = useAppSelector(
    (state) => state?.reportTotalRouteCompany?.total_real_revenue
  );
  const listTutorials = useAppSelector(
    (state) => state?.tutorials?.listTutorials
  );

  const limit_pagination: any = window.localStorage.getItem("limit_pagination");
  const limitPagination = isNaN(Number(limit_pagination))
    ? Constant.PAGE_SIZE
    : Number(limit_pagination);

  const watchTypeDateReport = Form.useWatch("type_date_report", form);
  const watchRoute = Form.useWatch("route", form);

  const handleGetListRoute = async () => {
    const response = await getListRouteAPI();
    if (response) {
      const listRoute: ValueOptions[] = response?.data?.data?.map(
        (route: RouteItemProps) => ({
          value: route?.id,
          label: `${route?.depart_point} - ${route?.arrive_point}`,
        })
      );
      listRoute.unshift({
        value: "",
        label: "Tất cả các tuyến",
      });
      setOptionsRoute(listRoute);
    }
  };

  const handleChangeRoute = async (value: number | string) => {
    dispatch(setFilterRoute(value));
  };

  useEffect(() => {
    handleGetListRoute();
  }, []);

  const onChangePage = async (page: number, pageSize: number) => {
    if (pagination?.per_page !== pageSize) {
      setPage(Constant.DEFAULT_PAGE);
      dispatch(setPerPage(pageSize));
    } else {
      setPage(page);
    }
    await dispatch(
      getListReportTotalRouteCompany({
        booking_date: watchTypeDateReport,
        from: dayjs(timeReport?.[0]).format("YYYY-MM-DD"),
        to: dayjs(timeReport?.[1]).format("YYYY-MM-DD"),
        route_id: watchRoute?.label ? watchRoute?.value : watchRoute,
        page: pagination?.per_page !== pageSize ? Constant.DEFAULT_PAGE : page,
        limit: pageSize,
      })
    );
  };

  const onFinish: FormProps<any>["onFinish"] = async (values) => {
    setPage(Constant.DEFAULT_PAGE);
    const response = await dispatch(
      getListReportTotalRouteCompany({
        booking_date: watchTypeDateReport,
        from: dayjs(timeReport?.[0]).format("YYYY-MM-DD"),
        to: dayjs(timeReport?.[1]).format("YYYY-MM-DD"),
        route_id: watchRoute?.label ? watchRoute?.value : watchRoute,
        page: Constant.DEFAULT_PAGE,
        limit: pagination?.per_page || limitPagination,
      })
    );
    if (response?.payload?.success) {
      toast.success(response?.payload?.message);
    }
  };

  const handleGetListReportBegin = async () => {
    setPage(Constant.DEFAULT_PAGE);
    if (listFilter?.from && listFilter?.to) {
      await dispatch(
        getListReportTotalRouteCompany({
          booking_date: listFilter?.booking_date,
          from: dayjs(listFilter?.from).format("YYYY-MM-DD"),
          to: dayjs(listFilter?.to).format("YYYY-MM-DD"),
          route_id: listFilter?.route_id,
          page: Constant.DEFAULT_PAGE,
          limit: pagination?.per_page || limitPagination,
        })
      );
    }
  };

  useEffect(() => {
    handleGetListReportBegin();
    if (listFilter?.from && listFilter?.to) {
      setTimeReport([
        dayjs(listFilter?.from, "YYYY-MM-DD"),
        dayjs(listFilter?.to, "YYYY-MM-DD"),
      ]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const columns: TableColumnsType<DataReport> = [
    {
      title: "Tuyến",
      dataIndex: "route",
      render: (route) => (
        <Typography.Text className="fs-16 text-color fw-500">{`${route?.depart_point} - ${route?.arrive_point}`}</Typography.Text>
      ),
      sorter: (a, b) =>
        `${a?.route?.depart_point} - ${a?.route?.arrive_point}`.localeCompare(
          `${b?.route?.depart_point} - ${b?.route?.arrive_point}`
        ),
    },
    {
      title: "SL vé nhà xe đã bán",
      align: "right",
      dataIndex: "total_booking_car_company",
      render: (total_booking_car_company) => (
        <Typography.Text className="fs-16 text-color fw-500">
          {total_booking_car_company
            ? formatPrice(total_booking_car_company, 0, ",")
            : 0}
        </Typography.Text>
      ),
    },
    {
      title: "SL vé đại lý đã bán",
      align: "right",
      dataIndex: "total_booking_agent",
      render: (total_booking_agent) => (
        <Typography.Text className="fs-16 text-color fw-500">
          {total_booking_agent ? formatPrice(total_booking_agent, 0, ",") : 0}
        </Typography.Text>
      ),
    },
    {
      title: "Chiết khấu đại lý",
      dataIndex: "total_commision",
      align: "right",
      render: (total_commision) => (
        <Typography.Text className="fs-16 text-color fw-500">
          {total_commision ? formatPrice(total_commision, 0, ",") : 0}
        </Typography.Text>
      ),
    },
    {
      title: "Tổng tiền giá vé",
      dataIndex: "total_price",
      align: "right",
      render: (total_price) => (
        <Typography.Text className="fs-16 text-color fw-500">
          {total_price ? formatPrice(total_price, 0, ",") : 0}
        </Typography.Text>
      ),
    },
    {
      title: "Tổng tiền thực thu",
      dataIndex: "total_real_revenue",
      align: "right",
      render: (total_real_revenue) => (
        <Typography.Text className="fs-16 text-color fw-500">
          {total_real_revenue ? formatPrice(total_real_revenue, 0, ",") : 0}
        </Typography.Text>
      ),
    },
  ];

  const handleGetLabelRoute = (value: number | string) => {
    const routeCurrent = optionsRoute?.find((route) => route?.value === value);
    return routeCurrent?.label || "Tất cả các tuyến";
  };

  const handleGetLabelTypeDateRoute = (value: string) => {
    const typeCurrent = optionsBookingDate?.find(
      (type) => type?.value === value
    );
    return typeCurrent?.label;
  };

  const onChangeTypeDateReport = (type: string) => {
    dispatch(setFilterBookingDate(type));
  };

  const onChangeTimeReport = (value: RangePickerProps["value"]) => {
    setTimeReport(value);
    setTimeReport(value);
    dispatch(setFilterRangeDate(value));
  };

  const columnsExport: IExcelColumn[] = [
    {
      title: "Tuyến",
      dataIndex: "route",
      width: 40,
      __excelTitle__: "Tuyến",
      __style__: {
        fontName: "Times New Roman",
        fontSize: 14,
        border: true,
        borderColor: "black",
      },
    },
    {
      title: "SL vé nhà xe đã bán",
      dataIndex: "total_booking_car_company",
      __cellType__: "TypeNumeric",
      __excelTitle__: "SL vé nhà xe đã bán",
      width: 30,
      __numFmt__: "#,##0",
      __style__: {
        fontName: "Times New Roman",
        fontSize: 14,
        border: true,
        borderColor: "black",
        h: "right",
      },
    },
    {
      title: "SL vé đại lý đã bán",
      dataIndex: "total_booking_agent",
      __cellType__: "TypeNumeric",
      __excelTitle__: "SL vé đại lý đã bán",
      __numFmt__: "#,##0",
      width: 30,
      __style__: {
        fontName: "Times New Roman",
        fontSize: 14,
        border: true,
        borderColor: "black",
        h: "right",
      },
    },
    {
      title: "Chiết khấu đại lý",
      dataIndex: "total_commision",
      __cellType__: "TypeNumeric",
      __excelTitle__: "Chiết khấu đại lý",
      __numFmt__: "#,##0",
      width: 20,
      __style__: {
        fontName: "Times New Roman",
        fontSize: 14,
        border: true,
        borderColor: "black",
        h: "right",
      },
    },
    {
      title: "Tổng tiền giá vé",
      dataIndex: "total_price",
      __cellType__: "TypeNumeric",
      __excelTitle__: "Tổng tiền giá vé",
      __numFmt__: "#,##0",
      width: 20,
      __style__: {
        fontName: "Times New Roman",
        fontSize: 14,
        border: true,
        borderColor: "black",
        h: "right",
      },
    },
    {
      title: "Tổng tiền thực thu",
      dataIndex: "total_real_revenue",
      __cellType__: "TypeNumeric",
      // __excelTitle__: "Tổng tiền giá vé",
      __numFmt__: "#,##0",
      width: 20,
      __style__: {
        fontName: "Times New Roman",
        fontSize: 14,
        border: true,
        borderColor: "black",
        h: "right",
      },
    },
  ];

  const handleExportExcel = async () => {
    const response: any = await dispatch(
      getListReportTotalRouteCompanyExcel({
        booking_date: watchTypeDateReport,
        from: dayjs(timeReport?.[0]).format("YYYY-MM-DD"),
        to: dayjs(timeReport?.[1]).format("YYYY-MM-DD"),
        route_id: watchRoute?.label ? watchRoute?.value : watchRoute,
      })
    );
    if (!response?.error) {
      const listData = response?.payload?.data;
      const totalPrice = response?.payload?.total_prices;
      const totalBookingsCarCompany =
        response?.payload?.total_bookings_car_company;
      const totalBookingsAgent = response?.payload?.total_bookings_agent;
      const totalCommissions = response?.payload?.total_commissions;
      const totalRealRevenue = response?.payload?.total_real_revenue;

      const listDataExcel =
        listData?.length > 0
          ? listData?.map((report: DataReport) => ({
              route: `${report?.route?.depart_point} - ${report?.route?.arrive_point}`,
              total_booking_car_company: report?.total_booking_car_company
                ? Number(report?.total_booking_car_company)
                : 0,
              total_booking_agent: report?.total_booking_agent
                ? Number(report?.total_booking_agent)
                : 0,
              total_commision: report?.total_commision
                ? Number(report?.total_commision)
                : 0,
              total_price: report?.total_price
                ? Number(report?.total_price)
                : 0,
              total_real_revenue: report?.total_real_revenue
                ? Number(report?.total_real_revenue)
                : 0,
            }))
          : [];
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Báo cáo tổng hợp theo tuyến");
      const header = columnsExport.map((col) => ({
        header: col.title,
        key: col.dataIndex as string,
      }));
      worksheet.columns = header;
      columnsExport.forEach((col, index) => {
        worksheet.getColumn(index + 1).width = col.width || 15;
        worksheet.getColumn(index + 1).alignment = {
          horizontal:
            (col?.__style__?.h as
              | "center"
              | "left"
              | "right"
              | "fill"
              | "justify") || "left",
          vertical: "middle",
        };
        worksheet.getColumn(index + 1).numFmt = col.__numFmt__ || "general";
      });
      worksheet.addRows(listDataExcel);
      worksheet.getRow(1).font = {
        name: "Times New Roman",
        size: 12,
        bold: true,
      };
      worksheet.getRow(1).eachCell((cell, colNumber) => {
        if (colNumber < 7) {
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "3AB54A" },
          };
          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };
        }
      });
      let firstRowHasData = false;
      worksheet.getRow(1).eachCell((cell, colNumber) => {
        if (cell.value) {
          firstRowHasData = true;
          return;
        }
      });
      if (firstRowHasData) {
        worksheet.eachRow({ includeEmpty: true }, (row, rowNumber) => {
          if (rowNumber > 1) {
            row.eachCell((cell) => {
              cell.font = { name: "Times New Roman", size: 12 };
              cell.border = {
                top: { style: "thin" },
                left: { style: "thin" },
                bottom: { style: "thin" },
                right: { style: "thin" },
              };
            });
          }
        });
      } else {
        worksheet.eachRow((row, rowNumber) => {
          if (rowNumber > 1) {
            let hasData = false;
            row.eachCell((cell) => {
              if (cell.value) {
                hasData = true;
                return;
              }
            });
            if (hasData) {
              row.border = {
                top: { style: "thin" },
                left: { style: "thin" },
                bottom: { style: "thin" },
                right: { style: "thin" },
              };
            }
          }
        });
      }
      const startColumnIndex = 1;

      const subLastRow = worksheet.addRow([]);
      subLastRow.getCell(1).value = "TỔNG (VND)";
      subLastRow.getCell(1).alignment = {
        vertical: "middle",
        horizontal: "left",
      };
      subLastRow.getCell(1).font = {
        name: "Times New Roman",
        size: 14,
        bold: true,
      };
      subLastRow.getCell(2).value = totalBookingsCarCompany;
      subLastRow.getCell(3).value = totalBookingsAgent;
      subLastRow.getCell(4).value = totalCommissions;
      subLastRow.getCell(5).value = totalPrice;
      subLastRow.getCell(6).value = totalRealRevenue;
      subLastRow.eachCell((cell) => {
        cell.font = { name: "Times New Roman", size: 14, bold: true };
        cell.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };
      });

      const lastRow = worksheet.addRow([]);
      lastRow.getCell(1).value = "@Bản quyền thuộc nhà xe Carlink";
      lastRow.getCell(1).alignment = {
        vertical: "middle",
        horizontal: "left",
      };
      lastRow.getCell(1).font = {
        name: "Times New Roman",
        size: 14,
        bold: true,
      };

      const endColumnIndex = startColumnIndex + columnsExport.length - 1;
      worksheet.mergeCells(lastRow.number, 1, lastRow.number, endColumnIndex);

      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "Báo cáo tổng hợp theo tuyến.xlsx";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    }
  };

  const filterOptionRoute = (
    input: string,
    option?: {
      label?: any;
      value?: any;
    }
  ) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase());
  const systemConfig = useAppSelector((state) => state.systemConfig?.result);
  const disabledDaysDate = useCallback(
    (current: any, { from }: any) => {
      if (from) {
        return (
          Math.abs(current.diff(from, "days")) >=
          systemConfig?.export_report_month
        );
      }
      return false;
    },
    [systemConfig?.export_report_month]
  );

  return (
    <div className="Report bg-white">
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        initialValues={{
          type_date_report: listFilter?.booking_date,
          range_date_report: [
            listFilter?.from
              ? dayjs(listFilter?.from, "DD/MM/YYYY")
              : undefined,
            listFilter?.to ? dayjs(listFilter?.to, "DD/MM/YYYY") : undefined,
          ],
          route:
            listFilter?.route_id === ""
              ? { value: listFilter?.route_id, label: "Chọn tuyến" }
              : listFilter?.route_id,
        }}
      >
        <Row gutter={12}>
          <Col className="Report__typeDateReport">
            <Form.Item<FieldType>
              className="required"
              name="type_date_report"
              label="Khoảng thời gian"
              rules={[
                { required: true, message: "Vui lòng chọn khoảng thời gian" },
              ]}
              initialValue={false}
            >
              <Select
                placeholder="Theo ngày khởi hành"
                options={optionsBookingDate}
                onChange={onChangeTypeDateReport}
              />
            </Form.Item>
          </Col>
          <Col className="Report__rangeDateReport">
            <Form.Item<FieldType>
              name="range_date_report"
              rules={[
                { required: true, message: "Vui lòng chọn khoảng thời gian" },
              ]}
            >
              <RangePicker
                disabledDate={disabledDaysDate}
                format="DD/MM/YYYY"
                onChange={onChangeTimeReport}
                popupClassName="Report__timeReport__picker"
                placeholder={["Từ ngày", "Đến ngày"]}
              />
            </Form.Item>
          </Col>
        </Row>
        <Flex align="center" gap={"small"} className="mb-24">
          <Image
            preview={false}
            width={20}
            height={20}
            className="d-flex"
            src={IconExclamationCircle}
            alt="Icon Exclamation Circle"
          />
          <Typography.Text className="fs-14 fw-500 text-color">
            Vui lòng chọn khoảng thời gian để xem báo cáo
          </Typography.Text>
        </Flex>
        <Typography.Text className="fs-6 fw-500 text-color d-block mb-8">
          Bộ lọc nâng cao
        </Typography.Text>
        <Flex gap={"small"}>
          <Form.Item<FieldType> className="Report__route" name="route">
            <Select
              onChange={handleChangeRoute}
              options={optionsRoute}
              popupClassName="Report__popup"
              showSearch
              filterOption={filterOptionRoute}
            />
          </Form.Item>
        </Flex>
        <Flex align="center" justify="space-between">
          <Form.Item className="Report__submit">
            <ConfigProvider theme={{ token: { colorPrimary: "#435869" } }}>
              <Button
                disabled={
                  timeReport?.length === 2 ||
                  (listFilter?.from && listFilter?.to)
                    ? false
                    : true
                }
                className="d-flex align-items-center h-auto"
                type="primary"
                htmlType="submit"
              >
                <IconFileExport width={16} height={16} />
                Xem báo cáo
              </Button>
            </ConfigProvider>
          </Form.Item>
          <TutorialsVideo url_youtube={handleGetUrlGuide(listTutorials, 2)} />
        </Flex>
        <Divider />
        <Flex>
          <ConfigProvider theme={{ token: { colorPrimary: "#435869" } }}>
            <Button
              ghost
              disabled={
                timeReport?.length === 2 || (listFilter?.from && listFilter?.to)
                  ? false
                  : true
              }
              onClick={handleExportExcel}
              className={`Report__exportExcel d-flex align-items-center mr-12 h-auto ${
                timeReport?.length === 2 || (listFilter?.from && listFilter?.to)
                  ? ""
                  : "disabled"
              }`}
              type="primary"
            >
              <IconExportExcel
                color={`${
                  timeReport?.length === 2 ||
                  (listFilter?.from && listFilter?.to)
                    ? "#435869"
                    : "#949494"
                }`}
                width={16}
                height={16}
              />
              Xuất Excel
            </Button>
          </ConfigProvider>
        </Flex>
        <Typography.Text className="d-block text-color-gray-3A3A3A fs-18 fw-600 mt-24 mb-8">
          Báo cáo tổng hợp theo tuyến (
          {handleGetLabelTypeDateRoute(watchTypeDateReport)})
        </Typography.Text>
        <Flex wrap="wrap" align="center" className="Report__filter">
          {timeReport && (
            <Flex align="center" className="Report__filter__item">
              <Typography.Text className="d-block fs-16 fw-500">
                Từ ngày:
              </Typography.Text>
              <Typography.Text className="d-block fs-16 fw-600">
                {dayjs(timeReport?.[0]).format("DD/MM/YYYY")}
              </Typography.Text>
            </Flex>
          )}
          {timeReport && (
            <Flex align="center" className="Report__filter__item">
              <Typography.Text className="d-block fs-16 fw-500">
                Đến ngày:
              </Typography.Text>
              <Typography.Text className="d-block fs-16 fw-600">
                {dayjs(timeReport?.[1]).format("DD/MM/YYYY")}
              </Typography.Text>
            </Flex>
          )}
          <Flex align="center" className="Report__filter__item">
            <Typography.Text className="d-block fs-16 fw-500">
              Tuyến:
            </Typography.Text>
            <Typography.Text className="d-block fs-16 fw-600">
              {handleGetLabelRoute(watchRoute)}
            </Typography.Text>
          </Flex>
        </Flex>
      </Form>
      <Table
        className="Report__table"
        locale={{
          triggerDesc: "Sắp xếp tăng dần",
          triggerAsc: "Hủy sắp xếp",
          cancelSort: "Sắp xếp giảm dần",
        }}
        pagination={{
          total: pagination?.total,
          current: page,
          pageSize: pagination?.per_page ?? DEFAULT_PAGE_SIZE,
          position: ["bottomRight"],
          onChange: onChangePage,
          showSizeChanger: true,
        }}
        dataSource={listReport?.length > 0 ? listReport : []}
        loading={loadingListReport}
        columns={columns}
        summary={(pageData) => {
          return (
            listReport?.length > 0 &&
            page === pagination?.last_page && (
              <>
                <Table.Summary.Row>
                  <Table.Summary.Cell index={0}>
                    <Flex align="center" gap="middle">
                      <Typography.Text className="text-color-default fw-700 fs-16">
                        TỔNG
                      </Typography.Text>
                      <Typography.Text className="text-color-default fw-500 fs-16">
                        (VND)
                      </Typography.Text>
                    </Flex>
                  </Table.Summary.Cell>
                  <Table.Summary.Cell align="right" index={1}>
                    <Typography.Text className="text-color-default text-end fw-700 fs-16">
                      {totalBookingsCarCompany
                        ? formatPrice(totalBookingsCarCompany, 0, ",")
                        : 0}
                    </Typography.Text>
                  </Table.Summary.Cell>
                  <Table.Summary.Cell align="right" index={2}>
                    <Typography.Text className="text-color-default text-end fw-700 fs-16">
                      {totalBookingsAgent
                        ? formatPrice(totalBookingsAgent, 0, ",")
                        : 0}
                    </Typography.Text>
                  </Table.Summary.Cell>
                  <Table.Summary.Cell align="right" index={3}>
                    <Typography.Text className="text-color-default text-end fw-700 fs-16">
                      {totalCommission
                        ? formatPrice(totalCommission, 0, ",")
                        : 0}
                    </Typography.Text>
                  </Table.Summary.Cell>
                  <Table.Summary.Cell align="right" index={4}>
                    <Typography.Text className="text-color-default text-end fw-700 fs-16">
                      {totalPrice ? formatPrice(totalPrice, 0, ",") : 0}
                    </Typography.Text>
                  </Table.Summary.Cell>

                  <Table.Summary.Cell align="right" index={5}>
                    <Typography.Text className="text-color-default text-end fw-700 fs-16">
                      {totalRealRevenue
                        ? formatPrice(totalRealRevenue, 0, ",")
                        : 0}
                    </Typography.Text>
                  </Table.Summary.Cell>
                </Table.Summary.Row>
              </>
            )
          );
        }}
      />
    </div>
  );
};

export default ReportTotalRouteCompany;
